const { connect } = require('react-redux');
const gameComponent = require('../component/gameComponent').default;
const { actions } = require('../../../reducers').default;
const { modalType } = require('../../../define/screenType').default;
// ============================

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGameMount: () => {
            dispatch(actions.modalEnable(modalType.MODAL_SCENARIO));
            dispatch(actions.initStage(1));
        },
        toggleSound: () => {
            dispatch(actions.soundChange());
        },
        onPause: () => {
            dispatch(actions.gamePause());
        },
        onClearStage: (bonus) => {
            dispatch(actions.addScore(bonus));
            dispatch(actions.clearStage());
        },
        onTimeOver: () => {
            dispatch(actions.gameOver());
        },
        onClearGame: () => {
            dispatch(actions.gameClear());
        },
        onClickSelector: index => {
            dispatch(actions.rotateBox(index));
        },
        onDropPorinBox: (array, frameId) => {
            dispatch(actions.placementBox(array, frameId))
        },
        onDropSkill: array => {
            dispatch(actions.placementSkill());
            dispatch(actions.doDamages(array));
        },
        onChainDamage: array => {
            dispatch(actions.doDamages(array));
        },
        onDeleteItem: (posX, posY) => {
            dispatch(actions.deleteObject(posX, posY));
        },
        onBreakTreasure: () => {
            dispatch(actions.breakTreasure());
        },
        onChangeItem: (posX, posY, object, hp, bonus) => {
            dispatch(actions.changeObject(posX, posY, object, hp, bonus));
        },
        onSkillCoolTimeEnd: () => {
            dispatch(actions.endCoolTime());
        },
        addScore: (point) => {
            dispatch(actions.addScore(point));
        }
    };
};

export const GameContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(gameComponent);